import React from 'react'
import { sdk } from '@/lib/sdk'
import type { Badge } from '@/types/badges'

/* One catalog request per minute while pickers and workflow blocks are on screen (owner and admin only: anyone else gets []). */
let cache: { at: number; promise: Promise<Badge[]> } | null = null
/* The names already read, for places that draw synchronously (a workflow block's subtitle). */
const names = new Map<string, string>()

export const loadBadgeCatalog = (fresh = false): Promise<Badge[]> => {
  if (fresh || !cache || Date.now() - cache.at > 60_000) {
    const promise = sdk.badges.list()
      .then((list) => {
        for (const b of list) names.set(b.id, b.name)
        return list
      })
      .catch(() => [] as Badge[])
    cache = { at: Date.now(), promise }
  }
  return cache.promise
}

/** Called after the catalog changes, so the next picker reads it again. */
export const forgetBadgeCatalog = () => { cache = null }

/** A badge's name, when the catalog was already read; `undefined` otherwise. */
export const badgeNameOf = (id: string): string | undefined => names.get(id)

/** The catalog; with `enabled` false nothing is asked (a screen that may not need it). */
export const useBadgeCatalog = (enabled = true) => {
  const [badges, setBadges] = React.useState<Badge[] | null>(null)
  React.useEffect(() => {
    if (!enabled) return
    let alive = true
    void loadBadgeCatalog().then((list) => { if (alive) setBadges(list) })
    return () => { alive = false }
  }, [enabled])
  return badges
}
